import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import Select from "react-select";
import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import { actualizarUsuarioWeb, crearUsuarioWeb } from "../../../api/api-usuario-web";
import { obtenerListaRolUsuarioWeb } from "../../../api/api-rol-usuario-web";
import BtnRequestComponent from "../../../components/btn-request";
import { obtenerListaPais } from "../../../api/api-pais";
import { obtenerListaCiudadPorPais } from "../../../api/api-ciudad";
import { obtenerListaCliente } from "../../../api/api-cliente";

export default function UsuarioWebPage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");

  const [listaRolUsuarioWeb, setListaRolUsuarioWeb] = useState([]);
  const [rolUsuarioWebSelected, setRolUsuarioWebSelected] = useState(null);

  const [listaPais, setListaPais] = useState([]);
  const [paisSelected, setPaisSelected] = useState(null);
  const [listaCiudad, setListaCiudad] = useState([]);
  const [ciudadSelected, setCiudadSelected] = useState(null);

  const [listaCliente, setListaCliente] = useState([]);
  const [clienteSelected, setClienteSelected] = useState(null);

  const [sendRequest, setSendRequest] = useState(false);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning");

  useEffect(() => {
    // console.log("entro a Correos");
    iniciar();
  }, []);

  useEffect(() => {
    if (paisSelected !== undefined && paisSelected !== null) {
      setCiudadSelected(null);
      buscarCiudadesPorPais();
    }
    if (paisSelected === null) {
      setListaCiudad([]);
      setCiudadSelected(null);
    }
  }, [paisSelected]);

  useEffect(() => {
    // Clear cliente when there is no role, or the role is not a client role.
    // Do NOT clear when esCliente === 1 — that would wipe the value set in iniciar() on edit.
    if (
      rolUsuarioWebSelected === null ||
      rolUsuarioWebSelected === undefined ||
      rolUsuarioWebSelected.esCliente !== 1
    ) {
      setClienteSelected(null);
    }
  }, [rolUsuarioWebSelected]);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
      }

      const [paises, roles, clientes] = await Promise.all([
        obtenerListaPais({ habilitado: 1 }, true, t),
        obtenerListaRolUsuarioWeb({ habilitado: 1 }, true, t),
        obtenerListaCliente({ habilitado: 1 }, true, t),
      ]);

      // const roles = await obtenerListaRolUsuarioWeb({ habilitado: 1 }, true, t);
      // console.log("roles");
      // console.log(roles);
      setListaRolUsuarioWeb(roles);
      if (data.params.idRolUsuarioWeb !== undefined && data.params.idRolUsuarioWeb !== null) {
        const rol = roles.find((item) => item.value === data.params.idRolUsuarioWeb);
        setRolUsuarioWebSelected(rol);
      }

      setListaPais(paises);
      if (data.params.idPais !== undefined && data.params.idPais !== null) {
        const pais = paises.find((item) => item.value === data.params.idPais);
        setPaisSelected(pais);
        if (pais !== undefined && pais !== null) {
          const response = await obtenerListaCiudadPorPais({ idPais: pais.value }, true, t);
          setListaCiudad(response);
          if (data.params.idCiudad !== undefined && data.params.idCiudad !== null) {
            const ciudad = response.find((item) => item.value === data.params.idCiudad);
            setCiudadSelected(ciudad !== undefined ? ciudad : null);
          }
        }
      }
      setListaCliente(clientes);
      if (data.params.idCliente !== undefined && data.params.idCliente !== null) {
        const cliente = clientes.find((item) => item.value === data.params.idCliente);
        // console.log("cliente");
        // console.log(cliente);
        setClienteSelected(cliente);
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
    }
  };

  const charLimits = {
    nombreUsuario: 64,
    password: 10,
    confirmarPassword: 10,
    nota: 256,
  };

  const buscarCiudadesPorPais = async () => {
    try {
      // console.log('buscarCiudadesPorPais');
      setProcessingVisible(true);
      const response = await obtenerListaCiudadPorPais({ idPais: paisSelected.value }, true, t);
      setListaCiudad(response);
    } catch (err) {
      console.log('buscarCiudadesPorPais err');
      console.log(err);
    } finally {
      setProcessingVisible(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Regular handling for other fields
    if (value.length <= charLimits[name]) {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      if (rolUsuarioWebSelected === null || rolUsuarioWebSelected === undefined) {
        message = message + t("alert_debe_seleccionar_rol_usuario_web") + '\n';
      }
      if (String(formData.nombreUsuario).trim().length === 0) {
        message = message + t("alert_debe_ingresar_nombre_usuario") + '\n';
      }
      if (String(formData.password).trim().length === 0) {
        message = message + t("alert_debe_ingresar_password") + '\n';
      }
      if (String(formData.confirmarPassword).trim().length === 0) {
        message = message + t("alert_debe_ingresar_confirmar_password") + '\n';
      }

      if (formData.password !== formData.confirmarPassword) {
        message = message + t("alert_la_contraseña_y_la_confirmación_de_la_contraseña_no_coinciden") + '\n';
      }

      if (rolUsuarioWebSelected?.esCliente === 1 && clienteSelected === null) {
        message = message + t("alert_debe_seleccionar_cliente") + '\n';
      }

      if (message.length > 0) {
        showToast(message, "error", 3000);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarFormulario err');
      console.log(err);
      return false;
    }
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    const valido = validarFormulario();
    if (valido === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    objEnviar.nombreUsuario = formData.nombreUsuario;
    objEnviar.password = formData.password;
    objEnviar.confirmarPassword = formData.confirmarPassword;
    objEnviar.idRolUsuarioWeb = rolUsuarioWebSelected.value;
    objEnviar.nota = formData?.nota ?? "";
    objEnviar.idPais = paisSelected?.value;
    objEnviar.idCiudad = ciudadSelected?.value;
    objEnviar.idCliente = clienteSelected?.value;
    setProcessingVisible(true);
    if (formData.id === 0) {
      // console.log('crear correo');
      setSendRequest(true);
      const response = await crearUsuarioWeb(objEnviar);
      setProcessingVisible(false);
      setSendRequest(false);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        showToast(t("alert_se_creo_correctamente"));
        handleCancelClick();
      }
      if (response.error === true) {
        showToast(t("alert_no_se_pudo_crear"));
      }
    }
    if (formData.id !== 0) {
      // console.log('actualizar correo');
      setSendRequest(true);
      const response = await actualizarUsuarioWeb(objEnviar);
      setSendRequest(false);
      setProcessingVisible(false);
      // console.log('modificado');
      // console.log(modificado);
      if (response.error === false) {
        showToast(t("alert_se_modifico_correctamente"));
        handleCancelClick();
      }
      if (response.error === true) {
        showToast(t("alert_no_se_pudo_modificar"));
      }
    }
  };

  const render = () => {
    // console.log('render correo');
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="rol-usuario-web">
                  {t("label_rol_usuario_web")}<span className="text-red-500">*</span>
                </label>
                <Select options={listaRolUsuarioWeb}
                  isSearchable={true}
                  isClearable={true}
                  value={rolUsuarioWebSelected}
                  onChange={(event) => setRolUsuarioWebSelected(event)}
                  placeholder={t("placeholder_seleccione_rol_usuario_web")}
                />
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                {
                  rolUsuarioWebSelected?.esCliente === 1 &&
                  <>
                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="rol-usuario-web">
                      {t("label_cliente")}<span className="text-red-500">*</span>
                    </label>
                    <Select options={listaCliente}
                      isSearchable={true}
                      isClearable={true}
                      value={clienteSelected}
                      onChange={(event) => setClienteSelected(event)}
                      placeholder={t("placeholder_seleccione_cliente")}
                    />
                  </>
                }
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
              </div>
            </div>
            {
              rolUsuarioWebSelected?.esCliente !== 1 &&
              <div className="grid grid-cols-12 gap-4 mt-4">
                <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                  <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="rol-usuario-web">
                    {t("label_pais")}
                  </label>
                  <Select options={listaPais}
                    isSearchable={true}
                    isClearable={true}
                    value={paisSelected}
                    onChange={(event) => setPaisSelected(event)}
                    placeholder={t("placeholder_seleccione_pais")}
                  />
                </div>
                <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                  <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="rol-usuario-web">
                    {t("label_ciudad")}
                  </label>
                  <Select options={listaCiudad}
                    isSearchable={true}
                    isClearable={true}
                    value={ciudadSelected}
                    onChange={(event) => setCiudadSelected(event)}
                    placeholder={t("placeholder_seleccione_ciudad")}
                  />
                </div>
              </div>
            }
            <div className="grid grid-cols-12 gap-4 mt-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nombreUsuario"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_nombre_usuario")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="nombreUsuario"
                  name="nombreUsuario"
                  type="text"
                  value={formData.nombreUsuario}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nombreUsuario}
                  placeholder={t("placeholder_ingresa_nombre_usuario")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.nombreUsuario.length}/{charLimits.nombreUsuario}</p>
              </div>
              {formData.id === 0 &&
                <>
                  <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                    <label
                      htmlFor="password"
                      className="block text-md font-medium text-gray-700"
                    >
                      {t("label_password")}<span className="text-red-500">*</span>
                    </label>
                    <input
                      id="password"
                      name="password"
                      type="text"
                      value={formData?.password ?? ""}
                      onChange={handleInputChange}

                      className={ESTILO_INPUT_GENERICO}
                      required
                      maxLength={charLimits.password}
                      placeholder={t("placeholder_ingresa_password")}
                    />
                    <p className="text-sm text-gray-500 flex justify-end">{formData?.password?.length ?? 0}/{charLimits.password}</p>
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                    <label
                      htmlFor="confirmarPassword"
                      className="block text-md font-medium text-gray-700"
                    >
                      {t("label_confirmar_password")}<span className="text-red-500">*</span>
                    </label>
                    <input
                      id="confirmarPassword"
                      name="confirmarPassword"
                      type="text"
                      value={formData?.confirmarPassword ?? ""}
                      onChange={handleInputChange}

                      className={ESTILO_INPUT_GENERICO}
                      required
                      maxLength={charLimits.confirmarPassword}
                      placeholder={t("placeholder_ingresa_password")}
                    />
                    <p className="text-sm text-gray-500 flex justify-end">{formData?.confirmarPassword?.length ?? 0}/{charLimits.confirmarPassword}</p>
                  </div>
                </>
              }
            </div>
            {/* <br /> */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nota"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_nota")}
                </label>
                <textarea
                  id="nota"
                  name="nota"
                  type="text"
                  value={formData.nota}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nota}
                  placeholder={t("placeholder_ingresa_nota")}
                  rows={5}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.nota?.length}/{charLimits.nota}</p>
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    {t("label_cancelar")}
                  </button>
                  {sendRequest === false && (
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_ACEPTAR}
                      onClick={handleSaveClick}
                    >
                      {t("label_aceptar")}
                    </button>
                  )}
                  {sendRequest === true && (
                    <BtnRequestComponent
                      label={t("label_aceptar")}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
